import { useState } from 'react';

export default useAutoIncrement;

export interface UseAutoIncrementProps {}

function useAutoIncrement(initial: number = 0): { getNextAutoIncrement: () => number } {
    const [counter, setCounter] = useState<number>(initial);
    const getNextAutoIncrement = () => {
        const newCounter = counter + 1;
        setCounter(newCounter);
        return newCounter;
    };
    return {
        getNextAutoIncrement,
    };
}
